/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getLog.defs.js'
export * as $defs from './getLog.defs.js'
